import React from "react";
import tamaraIcon from "../assets/images/Tamara1.png";
import madaIcon from "../assets/images/mada.png";
import mastercardIcon from "../assets/images/mastercard.png";
import payIcon from "../assets/images/pay.png";
import visaIcon from "../assets/images/visa.png";
import logo from "../assets/images/logo.png";
import footer_logo from "../assets/images/footer_logo_white.png";

const Footer = ({ setCurrentView }) => {
  const goAbout = () => {
    if (typeof setCurrentView === "function") {
      setCurrentView("about");
    }
  };

  return (
    <div className="footer-bar" dir="rtl">
      {/* ==== top row (current content) ==== */}
      <div className="footer-top d-flex justify-content-between align-items-center flex-wrap">
        <div className="search-item">
          <label>PARTECH احفظها،</label>
          <p>
            شركة سعودية موثوقة توفر جميع أنواع قطع غيار السيارات اليابانية , الأمريكية , الأوروبية
            و الصينية , بجودة عالية لتصل إليك بسهولة.
          </p>
        </div>

        <div className="search-item">
          <label>طرق الدفع الإلكترونية</label>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "10px",
              marginTop: "5px",
            }}
          >
            <img src={tamaraIcon} alt="تمارا" style={{ width: 42, height: 16 }} />
            <img src={madaIcon} alt="مدى" style={{ width: 42, height: 16 }} />
            <img src={mastercardIcon} alt="ماستر" style={{ width: 42, height: 16 }} />
            <img src={visaIcon  } alt="فيزا" style={{ width: 42, height: 16 }} />
            <img src={payIcon} alt="باي" style={{ width: 42, height: 16 }} />
          </div>
        </div>

        <div className="search-item">
          <label>تابعنا</label>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "10px",
              marginTop: "5px",
            }}
          >
            <a
              href="https://www.tiktok.com/@partech_ehfazha?_t=ZS-90081dETpGC&_r=1"
              className="text-white"
              target="blank"
            >
              <i className="bi bi-tiktok" />
            </a>
            <a
              href="https://www.instagram.com/partech_ehfazha/"
              className="text-white"
              target="blank"
            >
              <i className="bi bi-instagram" />
            </a>
            <a href="#" className="text-muted">
              <i className="bi bi-facebook" />
            </a>
            <a href="#" className="text-muted">
              <i className="bi bi-twitter-x" />
            </a>
            <a href="#" className="text-muted">
              <i className="bi bi-linkedin" />
            </a>
            <a href="#" className="text-muted">
              <i className="bi bi-snapchat" />
            </a>
          </div>
        </div>

        {/* Clickable "تعرف على بارتك" */}
        <div
          className="search-item"
          role="button"
          tabIndex={0}
          onClick={goAbout}
          onKeyDown={(e) =>
            e.key === "Enter" || e.key === " " ? goAbout() : null
          }
          style={{ cursor: "pointer" }}
          aria-label="تعرف على بارتك"
          title="تعرف على بارتك"
        >
          <label>تعرف على</label>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "10px",
              marginTop: "5px",
            }}
          >
            <img src={logo} alt="PARTECH" style={{ width: 170, height: "auto" }} />
          </div>
        </div>
      </div>

      {/* ==== bottom row (new) ==== */}
      <div className="footer-bottom d-flex flex-wrap justify-content-between align-items-center">
        <p className="mb-0">
        شركة احفظها ش.م.م - سجل تجاري رقم: 1009069725
        </p>
        {/* لو حاب تضيف نص ثاني على اليسار حطه هنا */}
        <p className="mb-0"><img src={footer_logo} width={25} alt="footer logo" style={{marginLeft:"10px", borderRadius:"3px"}} />موثق لدى المركز السعودي للأعمال</p>
        <p className="mb-0">رقم التوثيق | 0000204712</p>
      </div>
    </div>
  );
};

export default Footer;
